
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},_vm.$listeners),[_c('path',{attrs:{"d":"M12,1a11.052,11.052,0,1,0,7.882,3.326l-.1-.1A10.925,10.925,0,0,0,12,1m0-1A12,12,0,1,1,0,12,12,12,0,0,1,12,0"}}),_vm._v(" "),_c('path',{attrs:{"d":"M12,5a5,5,0,0,0-5,5c0,2.808,3.645,6.792,4.286,8.717.237.712.409,1.283.714,1.283s.477-.571.714-1.283C13.355,16.792,17,12.808,17,10a5,5,0,0,0-5-5m0,7a2,2,0,1,1,2-2,2,2,0,0,1-2,2","opacity":"0.3"}})])}
var staticRenderFns = []

    export default {
      render: render,
    }
  